<template lang="pug">
section.signup.full__video.noBoxShadow
  .fluid__video.splash.form__video--horizontal
    iframe(data-src='https://media.flixel.com/cinemagraph/mv7tif44u6c1vm9e30cs' allow='autoplay')
  .fluid__video.splash.form__video--vertical
    iframe(data-src='https://media.flixel.com/cinemagraph/ab06d2jrwa3ppzhdym0h?hd=true' allow='autoplay')
    .credit
      a(target='_blank' href='https://flixel.com/jimmycheung/') Jimmy Cheung

  .signup__form
    .message.error(v-show='error')
      p {{ error }}
      a.close(@click='error = false')
    form(name='loginform', v-on:submit.prevent='loginUser(login)')
      h1 Sign in to your account

      .ui-input
        p Username or Email
        input(type="text", name="username", v-model="login.username", placeholder=" Your username or email")

      .ui-input
        p Password
        input(type="password", name="password", v-model="login.password", placeholder=" Your password")

      button.btn.btn--purpleLight(type='submit') Sign In

      p Don't have an account?
      p
        router-link.link(to="/registration/") Sign up here
      p
        router-link.link(to="/forgot-password/") Forgot password?
</template>

<script>
import AuthService from 'services/auth.es6.js';
import AccountService from 'services/account.es6.js';
import ProfileService from 'services/profile.es6.js';

export default {
  name: 'Login',
  data() {
    return {
      error: null,
      loading: false,
      login: {
        username: null,
        password: null,
      },
      redirectUrl: '',
    };
  },
  metaInfo: {
    title: 'Login | Flixel',
    meta: [
      {
        'property': 'image',
        'content': 'https://cdn.flixel.com/static/static-web/Login.png',
      },
      {
        'property': 'description',
        'content': 'Login to your Flixel Plan subscription to start creating cinemagraphs with the best cinemagraph creation tools and services.',
      },
    ],
  },
  mounted() {
    const myLazyLoad = new LazyLoad({
      elements_selector: 'iframe, .lazy',
    });
  },
  methods: {
    // Promise #1 - Gets Access token
    getAccessTokenSuccess(data) {
      AuthService.storeAccessToken(data);
    },

    getAccessTokenError(error) {
      this.error = AuthService.rejectAccessToken(error);
      this.loading = false;
      return Promise.reject(error);
    },

    getAccessTokenInvoke(login) {
      return AuthService.getAccessToken(login)
        .then(this.getAccessTokenSuccess, this.getAccessTokenError);
    },

    // Promise #2 - Gets Account
    getAccountSuccess(data) {
      AuthService.updateUser('account', data.data);
      return data;
    },

    getAccountError(error) {
      this.error = error;
      return Promise.reject(error);
    },

    getAccountInvoke() {
      return AccountService.get()
        .then(this.getAccountSuccess, this.getAccountError);
    },

    // Promise #3 - Gets Profile
    getProfileSuccess(data) {
      AuthService.updateUser('profile', data);

      const username = JSON.parse(localStorage.getItem('account')).username;
      this.$router.push({ name: 'Profile', params: { username: username } });
    },

    getProfileError(error) {
      this.error = error;
      AuthService.logout('/login');
    },

    getProfileInvoke(data) {
      const username = data.data.username;
      ProfileService.get(username)
        .then(this.getProfileSuccess, this.getProfileError);
    },

    // Logging in user chains three promises:
    // access token, account, profile
    // we store all of these in session

    loginUser(credentials) {
      this.loading = true;
      const payload = {
        username: '',
        password: '',
      };

      payload.username = credentials.username;
      payload.password = credentials.password;
      this.getAccessTokenInvoke(payload)
        .then(this.getAccountInvoke)
        .then(this.getProfileInvoke)
        .finally(function () {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue